export default __webpack_public_path__ + "static/banner-bespoke-85d083421f51c75b856bbf6c85ada38d.jpeg";